/**
 * @generated SignedSource<<b829428e9bec33429f4cc8c196935175>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type DirectoryViewTeamQuery$variables = {
  cloudId: string;
  includeGoals: boolean;
  includeHasChildren: boolean;
  includeProjects: boolean;
  organisationId: string;
  teamQuery: string;
};
export type DirectoryViewTeamQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DirectoryViewPaginationQuery">;
};
export type DirectoryViewTeamQuery = {
  response: DirectoryViewTeamQuery$data;
  variables: DirectoryViewTeamQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeGoals"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeHasChildren"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeProjects"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organisationId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamQuery"
},
v6 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v7 = {
  "kind": "Variable",
  "name": "organisationId",
  "variableName": "organisationId"
},
v8 = [
  (v6/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 24
  },
  (v7/*: any*/),
  {
    "kind": "Variable",
    "name": "q",
    "variableName": "teamQuery"
  }
],
v9 = {
  "kind": "ScalarField",
  "name": "id"
},
v10 = {
  "kind": "ScalarField",
  "name": "description"
},
v11 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v12 = {
  "kind": "ScalarField",
  "name": "name"
},
v13 = {
  "kind": "ScalarField",
  "name": "count"
},
v14 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v15 = {
  "kind": "ScalarField",
  "name": "key"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "DirectoryViewTeamQuery",
    "selections": [
      {
        "args": [
          (v6/*: any*/),
          {
            "kind": "Variable",
            "name": "includeGoals",
            "variableName": "includeGoals"
          },
          {
            "kind": "Variable",
            "name": "includeHasChildren",
            "variableName": "includeHasChildren"
          },
          {
            "kind": "Variable",
            "name": "includeProjects",
            "variableName": "includeProjects"
          },
          (v7/*: any*/),
          {
            "kind": "Variable",
            "name": "teamQuery",
            "variableName": "teamQuery"
          }
        ],
        "kind": "FragmentSpread",
        "name": "DirectoryViewPaginationQuery"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "DirectoryViewTeamQuery",
    "selections": [
      {
        "args": (v8/*: any*/),
        "concreteType": "TeamSearchResponseConnection",
        "kind": "LinkedField",
        "name": "teamsTql",
        "plural": false,
        "selections": [
          {
            "concreteType": "TeamSearchResponseEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "TeamSearchResponse",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "displayName"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "smallAvatarImageUrl"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isVerified"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasChildren"
                  },
                  {
                    "concreteType": "TeamSearchResponseConnection",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "TeamSearchResponseEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          (v11/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "memberCount"
                  },
                  {
                    "concreteType": "TeamMemberConnection",
                    "kind": "LinkedField",
                    "name": "searchMembers",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "TeamMemberEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "TeamMember",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "UserPII",
                                "kind": "LinkedField",
                                "name": "pii",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "aaid"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "concreteType": "TeamType",
                    "kind": "LinkedField",
                    "name": "type",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "verified"
                      },
                      (v9/*: any*/),
                      (v10/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "largeAvatarImageUrl"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "state"
                  },
                  (v11/*: any*/),
                  {
                    "condition": "includeGoals",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "concreteType": "GoalConnection",
                        "kind": "LinkedField",
                        "name": "goals",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          {
                            "concreteType": "GoalEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "Goal",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  (v14/*: any*/),
                                  (v15/*: any*/),
                                  {
                                    "concreteType": "GoalIcon",
                                    "kind": "LinkedField",
                                    "name": "icon",
                                    "plural": false,
                                    "selections": [
                                      (v15/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "appearance"
                                      }
                                    ]
                                  },
                                  (v12/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "includeProjects",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "concreteType": "ProjectConnection",
                        "kind": "LinkedField",
                        "name": "projects",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          {
                            "concreteType": "ProjectEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "Project",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  (v15/*: any*/),
                                  (v12/*: any*/),
                                  (v14/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "private"
                                  },
                                  {
                                    "concreteType": "IconURIs",
                                    "kind": "LinkedField",
                                    "name": "iconUrl",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "ThemeURIs",
                                        "kind": "LinkedField",
                                        "name": "square",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "light"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "dark"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "transparent"
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v11/*: any*/),
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              },
              {
                "kind": "ScalarField",
                "name": "endCursor"
              }
            ]
          }
        ]
      },
      {
        "args": (v8/*: any*/),
        "filters": [
          "q",
          "organisationId",
          "cloudId"
        ],
        "handle": "connection",
        "key": "TeamDirectoryResults_teamsTql",
        "kind": "LinkedHandle",
        "name": "teamsTql"
      },
      {
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "preferences",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "wrapTextEnabled"
              },
              (v9/*: any*/)
            ]
          },
          (v9/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "e389f9bb176132090cdd3fea9ba22b3d",
    "id": null,
    "metadata": {},
    "name": "DirectoryViewTeamQuery",
    "operationKind": "query",
    "text": "query DirectoryViewTeamQuery(\n  $teamQuery: String!\n  $organisationId: String!\n  $cloudId: String!\n  $includeGoals: Boolean!\n  $includeProjects: Boolean!\n  $includeHasChildren: Boolean!\n) {\n  ...DirectoryViewPaginationQuery_3YbN6P\n}\n\nfragment DirectoryViewPaginationQuery_3YbN6P on Query {\n  teamsTql(q: $teamQuery, first: 24, organisationId: $organisationId, cloudId: $cloudId) {\n    ...DirectoryView_Results_3qWx6E\n    edges {\n      __typename\n      cursor\n      node {\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  currentUser {\n    preferences {\n      wrapTextEnabled\n      id\n    }\n    id\n  }\n}\n\nfragment DirectoryView_Results_3qWx6E on TeamSearchResponseConnection {\n  ...TeamsDirectoryListView_3qWx6E\n  ...TeamsDirectoryGridView\n}\n\nfragment GoalEntry on Goal {\n  ...GoalName\n}\n\nfragment GoalName on Goal {\n  uuid\n  id\n  key\n  ...PlatformGoalIcon\n  name\n}\n\nfragment PlatformGoalIcon on Goal {\n  icon {\n    key\n    appearance\n  }\n}\n\nfragment ProjectIcon on Project {\n  private\n  iconUrl {\n    square {\n      light\n      dark\n      transparent\n    }\n  }\n}\n\nfragment ProjectName_data on Project {\n  id\n  key\n  name\n  uuid\n  ...ProjectIcon\n}\n\nfragment RootTeamDirectoryRow_3qWx6E on TeamSearchResponse {\n  id\n  ...TeamDirectoryRowDetails_3qWx6E\n}\n\nfragment TeamActions on TeamSearchResponse {\n  id\n}\n\nfragment TeamDirectoryCardDetails on TeamSearchResponse {\n  id\n  description\n  displayName\n  isVerified\n  smallAvatarImageUrl\n  ...TeamSearchAvatar\n  memberCount\n  state\n  type {\n    id\n    name\n    description\n    verified\n  }\n  searchMembers {\n    edges {\n      node {\n        pii {\n          name\n          picture\n        }\n        aaid\n      }\n    }\n  }\n}\n\nfragment TeamDirectoryRowDetails_3qWx6E on TeamSearchResponse {\n  id\n  description\n  hasChildren @include(if: $includeHasChildren)\n  goals @include(if: $includeGoals) {\n    ...TeamGoals\n  }\n  projects @include(if: $includeProjects) {\n    ...TeamProjects\n  }\n  ...TeamNameColumn\n  ...TeamMemberAvatarColumn\n  ...TeamTypeColumn\n  ...TeamActions\n}\n\nfragment TeamGoals on GoalConnection {\n  count\n  edges {\n    node {\n      id\n      ...GoalEntry\n    }\n  }\n}\n\nfragment TeamMemberAvatarColumn on TeamSearchResponse {\n  memberCount\n  searchMembers {\n    edges {\n      node {\n        pii {\n          name\n          picture\n        }\n        aaid\n      }\n    }\n  }\n}\n\nfragment TeamNameColumn on TeamSearchResponse {\n  id\n  displayName\n  smallAvatarImageUrl\n  isVerified\n  hasChildren\n  description\n  children {\n    edges {\n      __typename\n    }\n  }\n}\n\nfragment TeamProjects on ProjectConnection {\n  count\n  edges {\n    node {\n      ...ProjectName_data\n      id\n    }\n  }\n}\n\nfragment TeamSearchAvatar on TeamSearchResponse {\n  id\n  displayName\n  isVerified\n  largeAvatarImageUrl\n}\n\nfragment TeamTypeColumn on TeamSearchResponse {\n  type {\n    name\n    verified\n    id\n  }\n}\n\nfragment TeamsDirectoryGridView on TeamSearchResponseConnection {\n  edges {\n    node {\n      id\n      ...TeamDirectoryCardDetails\n    }\n  }\n  pageInfo {\n    hasNextPage\n  }\n}\n\nfragment TeamsDirectoryListView_3qWx6E on TeamSearchResponseConnection {\n  edges {\n    node {\n      id\n      ...RootTeamDirectoryRow_3qWx6E\n    }\n  }\n  pageInfo {\n    hasNextPage\n  }\n}\n"
  }
};
})();

(node as any).hash = "e21d5ca1c7a5e710c12ef8d20448dc4f";

export default node;
